import React, { useState } from 'react'
import '../Styles/Main.css'
import { myProjects } from "../Pages/MyMainProjects";
import { AnimatePresence, motion } from "framer-motion";
import Header from './Header';
import { Link } from 'react-router-dom';


const Main = () => {
  const [currentActive, setcurrentActive] = useState("all");
  const [arr, setArr] = useState(myProjects);

  const handleClick = (buttonCategory) => {
    setcurrentActive(buttonCategory);

    const newArr = myProjects.filter((item) => {
      const ImgType = item.category.find((myItem) => {
        return myItem === buttonCategory;
      });

      return ImgType === buttonCategory;
    });

    setArr(newArr);
  };

  return (
    <>
      <Header />
      <main className="flex" id='Projects'>
        <section className="flex  left-section">
          <button
            onClick={() => {
              setcurrentActive("all");
              setArr(myProjects);
            }}
            className={currentActive === "all" ? "active" : null}
          >
            all projects
          </button>

          <button
            onClick={() => {
              handleClick("html-css");
            }}
            className={currentActive === "html-css" ? "active" : null}
          >
            HTML & CSS
          </button>

          <button
            onClick={() => {
              handleClick("javascript");
            }}
            className={currentActive === "javascript" ? "active" : null}
          >
            JavaScript
          </button>
          <button
            onClick={() => {
              handleClick("react");
            }}
            className={currentActive === "react" ? "active" : null}
          >
            React & Bootsrap
          </button>
        </section>

        <section className=" flex right-section">
          <AnimatePresence>
            {arr.map((item) => {
              return (
                <motion.article
                  layout
                  initial={{ transform: "scale(0.4)" }}
                  animate={{ transform: "scale(1)" }}
                  transition={{ type: "spring", damping: 8, stiffness: 50 }}
                  key={item.id}
                  className="  card" >
                  <img width={266} height={150} src={item.imgPath} alt="" />

                  <div style={{ width: "266px", }} className="box">
                    <h1 className="title">{item.projectTitle}</h1>
                    <p className="sub-title"  style={{ height: "92px", }}>
                      {item.description.length > 150
                        ? `${item.description.slice(0, 150)}...`
                        : item.description}
                    </p>

                    <div className="flex icons">
                      <div style={{ gap: "200px" }} className="flex">
                        <Link to={item.IframLink}  >
                          <div className="icon-link"></div>
                        </Link>

                        <Link to={item.GitHubLink}>
                          <div className="icon-github"></div>
                        </Link>
                      </div>
                                   
                    </div>
                  </div>
                </motion.article>
              );
            })}
          </AnimatePresence>


        </section>
      </main>
    </>

  );
};

export default Main;

